import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { ModuleHeaderComponent } from '../shared/components/module-header/module-header.component';
import { AccessProviderDirective } from '../shared/directives/access-provider.directive';
import { TabViewModule } from 'primeng/tabview';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { Router, ActivatedRoute } from '@angular/router';
import { AppIcons } from '../shared/app.icons';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ChartModule } from 'primeng/chart';
import { BudgetedVsForcastedWidgetComponent } from './components/budgeted-vs-forcasted-widget/budgeted-vs-forcasted-widget.component';
import { SOAProductVolumesComponent } from './components/soaproduct-volumes/soaproduct-volumes.component';
import { RemainingBudgetVsPOComponent } from './components/remaining-budget-vs-po/remaining-budget-vs-po.component';
import { ExpectedVsActivePatientsComponent } from './components/expected-vs-active-patients/expected-vs-active-patients.component';
import { SponsorCardsComponent } from './components/sponsor-cards/sponsor-cards.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { ForcastedSpendForNextBillingPeriodComponent } from './components/forcasted-spend-for-next-billing-period/forcasted-spend-for-next-billing-period.component';
import { ConfigService } from '../shared/services/config.service';
import { EntityService } from '../shared/services/entity.service';
import { QuickFilterFormComponent } from '../shared/components/quick-filter-form/quick-filter-form.component';
import { AppSettings } from '../shared/app.settings';
import { CommonBindingDataService } from '../shared/services/common-binding-data.service';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';
import { NoResultFoundComponent } from '../shared/components/no-result-found/no-result-found.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CardModule, CommonModule, FormsModule, TranslateModule,
    AutoCompleteModule, MessageModule,
    SOAProductVolumesComponent,
    RemainingBudgetVsPOComponent,
    ExpectedVsActivePatientsComponent,
    SponsorCardsComponent,
    OrderHistoryComponent,
    ForcastedSpendForNextBillingPeriodComponent,
    ModuleHeaderComponent, AccessProviderDirective, TabViewModule,
    QuickFilterFormComponent,
    SkeletonModule, TooltipModule, TabViewModule, BreadcrumbModule, ChartModule, BudgetedVsForcastedWidgetComponent, NoResultFoundComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  entityDataProtocol = {
    viewCode: 'AUTOCOMPLETE_VIEW',
    countryCode: '',
    forTenantCode: this.configService.getForTenantCode(),
    searchText: '',
    actionStatus: '',
    deleted: '',
    eventCode: '',
    filters: [],
    advanceFilters: []
  };
  selectedProtocol: any;
  filteredProtocolItems: any[] = [];
  country: any;
  placeholder = 'Select Protocol';
  selectedSite: any = { name: 'All', id: 'all' };
  filteredSiteItems: any[] = [];
  sitePlaceholder = 'Select Site';

  miIcons = AppIcons;
  activeIndex = 0;
  entityCount = {
    order_count: 10,
    pending_order_count: 10,
    completed_order_count: 10,
    rejected_order_count: 10,
    total_protocol_count: 10,
    completed_protocol_count: 10,
    running_protocol_count: 10,
    total_number_of_sites: 10,
    accpeted_order_count: 10,
    product_count: 10,
    site_count: 10,
    patient_count: 10,
    used_budget: 10,
    total_budget: 10,
    protocol_count: 100,
    completed_protocols: 40,
    running_protocols: 30,
  }

  productSoaCount: any = null;
  protocolForecastData: any = null;
  filterList: any = [];
  attributeValues: any = [];
  siteFilterList: any = [];
  orderCount = {
    total: 89,
    pending: 25,
    completed: 64,
    accepted: 52,
    rejected: 12
  };

  siteAndAdminCount: any = null;

  routePath: MenuItem[] = [];

  isSponsor = this.configService.isSponsorUser();
  isSiteUser = this.configService.isSiteUser();
  isAdmin = this.configService.isTenantAdmin() || this.configService.isReviewer();

  sampleSpendData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    budgeted: [12000, 15000, 18000, 14000, 16000, 19000, 17000, 20000, 22000, 18000, 21000, 24000],
    forecasted: [6000, 6000, 6000, 6000, 6000, 8000, 10000, 19500, 21500, 18500, 20500, 23500],
    actual: [0, 500, 2000, 4000, 6000, 8000, 16800, 19200, 20800, 17600, 19800, 22800]
  };

  isResize = true;

  constructor(private router: Router, private configService: ConfigService,
    private entityService: EntityService, private cs: CommonBindingDataService, private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.routePath = [
      { label: 'Dashboard', routerLink: '/dashboard' },
    ];
    this.restoreFilterStateFromQueryParams();
    this.checkUserType();
  }

  restoreFilterStateFromQueryParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      const protocolId = params.protocolId;
      const siteId = params.siteId;

      if (protocolId || siteId) {
        // Store these to be restored after data is loaded
        if (protocolId) {
          localStorage.setItem('dashboard_selected_protocol_id', protocolId);
        }
        if (siteId) {
          localStorage.setItem('dashboard_selected_site_id', siteId);
        }
      }
    });
  }

  checkUserType() {
    if (this.configService.isSponsor()) {
      this.initializeProtocolSelection();
    } else {
      this.getDashboardCount();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isResize = false;
    setTimeout(() => {
      this.isResize = true;
      this.initializeProtocolSelection();
      this.cdr.detectChanges();
    }, 100);
  }


  getSiteFilterView() {
    this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.PROTOCOL_SITE, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW, true).subscribe(res => {
      this.filterList = this.cs.getColumns(res);
      const protocolField = this.filterList.find(field => field.attributeCode === 'protocol_entity_id');

      this.siteFilterList = [{
        attributeId: protocolField?.attributeId,
        attributeValue: this.selectedProtocol.id
      }];
      this.setOrderFilterView();
      this.initializeSiteSelection();
    });
  }

  onTabChange() {
    // Tab change handler
  }

  navigateToTab(tabIndex: number) {
    this.activeIndex = tabIndex;
  }

  navigateToOrders() {
    this.router.navigate(['/app/orders']);
  }

  navigateToPendingOrders() {
    this.router.navigate(['/app/orders'], { queryParams: { status: 'pending' } });
  }

  navigateToCompletedOrders() {
    this.router.navigate(['/app/orders'], { queryParams: { status: 'completed' } });
  }

  navigateToRejectedOrders() {
    this.router.navigate(['/app/orders'], { queryParams: { status: 'rejected' } });
  }

  navigateToSites() {
    this.router.navigate(['/app/sites']);
  }

  navigateToProtocols() {
    this.router.navigate(['/app/trials']);
  }


  initializeProtocolSelection() {
    this.fetchFromAPI();
  }

  initializeSiteSelection() {
    this.fetchSitesFromAPI('AUTOCOMPLETE_VIEW', '');
  }

  filterProtocolItems(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    this.entityDataProtocol.searchText = query;
    this.fetchFromAPI();
  }


  setOrderFilterView() {
    if (this.configService.isSponsor()) {
      const entityProductSoaCount: any = {
        forTenantCode: this.configService.getForTenantCode(),
        protocolId: this.selectedProtocol.id
      }
      if (this.selectedSite && this.selectedSite.id !== 'all') {
        entityProductSoaCount.siteIds = [this.selectedSite.id];
      }
      this.entityService.getDashboardProductSoaCount(entityProductSoaCount).subscribe(data => {
        this.productSoaCount = data;
      });

      const entityDataForecast: any = {
        tenantCode: this.configService.getForTenantCode(),
        protocolId: this.selectedProtocol.id
      }
      if (this.selectedSite && this.selectedSite.id !== 'all') {
        entityDataForecast.siteId = this.selectedSite.id;
      }

      this.entityService.getProtocolForecastReport(entityDataForecast, true).subscribe(data => {
        this.protocolForecastData = data;
      });
    }
  }

  fetchFromAPI() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.entityDataProtocol.countryCode = this.country[0].countryCode;
    this.entityService.autoComplete(AppSettings.ENTITY_CODE.PROTOCOL, this.entityDataProtocol).subscribe(res => {
      const items = this.cs.getTableData(res) || [];
      this.filteredProtocolItems = items.map(item => ({
        name: item.product_name || item.name || item.site_name || item.delivery_name || item.protocol_name,
        id: item.id
      }));

      // Check if we need to restore a previously selected protocol
      const savedProtocolId = localStorage.getItem('dashboard_selected_protocol_id');

      if (savedProtocolId) {
        const savedProtocol = this.filteredProtocolItems.find(p => p.id === savedProtocolId);
        if (savedProtocol) {
          this.selectedProtocol = savedProtocol;
          localStorage.removeItem('dashboard_selected_protocol_id');
          this.getSiteFilterView();
          return;
        }
      }

      if (this.filteredProtocolItems.length > 0 && !this.selectedProtocol) {
        this.selectedProtocol = this.filteredProtocolItems[0];
        this.getSiteFilterView();
      }
    });
  }

  filterSiteItems(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    if (!query || query.trim() === '') {
      this.fetchSitesFromAPI('AUTOCOMPLETE_VIEW', '');
    } else {
      this.fetchSitesFromAPI('AUTOCOMPLETE_VIEW', query);
    }
  }

  onSelectItem(event: any) {
    this.selectedProtocol = event.value;
    this.selectedSite = { name: 'All', id: 'all' };
    this.filteredSiteItems = [];
    this.getSiteFilterView();
  }

  onSelectSite(event: any) {
    this.selectedSite = event.value;
    this.setOrderFilterView();
    this.cdr.detectChanges();
  }

  onSiteDropdownOpen() {
    if (this.filteredSiteItems.length === 0) {
      this.fetchSitesFromAPI('AUTOCOMPLETE_VIEW', '');
    }
  }

  onSiteFocus() {
    if (this.filteredSiteItems.length === 0) {
      this.fetchSitesFromAPI('AUTOCOMPLETE_VIEW', '');
    }
  }

  fetchSitesFromAPI(viewCode: string, search: string) {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const entityDataSite = {
      viewCode,
      countryCode: this.country[0].countryCode,
      forTenantCode: this.configService.getForTenantCode(),
      searchText: search || '',
      actionStatus: '',
      deleted: '',
      eventCode: '',
      filters: this.siteFilterList,
      advanceFilters: []
    };

    this.entityService.autoComplete(AppSettings.ENTITY_CODE.PROTOCOL_SITE, entityDataSite).subscribe(res => {
      const items = this.cs.getTableData(res) || [];

      this.filteredSiteItems = items.map(item => ({
        name: item.site_name || item.name,
        id: item.site_entity_id
      })).sort((a, b) => a.name.localeCompare(b.name));

      const allOption = { name: 'All', id: 'all' };
      const hasAllOption = this.filteredSiteItems.some(item => item.id === 'all');

      if (!hasAllOption) {
        this.filteredSiteItems.unshift(allOption);
      }

      // Check if we need to restore a previously selected site
      const savedSiteId = localStorage.getItem('dashboard_selected_site_id');

      if (savedSiteId) {
        const savedSite = this.filteredSiteItems.find(s => s.id === savedSiteId);
        if (savedSite) {
          this.selectedSite = savedSite;
          localStorage.removeItem('dashboard_selected_site_id');
          this.setOrderFilterView();
          this.cdr.detectChanges();
          return;
        }
      }

      if (this.filteredSiteItems.length > 0 && !this.selectedSite) {
        this.selectedSite = allOption;
      }
    });
  }



  getDashboardCount() {
    this.entityService.getDashboardCount({ forTenantCode: this.configService.getForTenantCode() }).subscribe(data => {
      this.siteAndAdminCount = data;
    });
  }
}
